import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './locales/en'
import cn from './locales/cn'

Vue.use(VueI18n)

const messages = { en, cn }
export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: messages
})



// WEBPACK FOOTER //
// ./src/language/index.js